import { useState } from 'react';

export const FullscreenButton = () => {
	const [fullscreen, setFullscreen] = useState(false);

	const launchFullscreen = async () => {
		const element = document.documentElement;

		if (element.requestFullscreen) {
			await element.requestFullscreen();
		} else if (element.mozRequestFullScreen) {
			// Firefox
			await element.mozRequestFullScreen();
		} else if (element.webkitRequestFullscreen) {
			// Chrome & Safari
			await element.webkitRequestFullscreen();
		} else if (element.msRequestFullscreen) {
			// IE
			await element.msRequestFullscreen();
		}

		setFullscreen(true);
	};

	return (
		<button
			type='button'
			className={`${fullscreen ? 'hidden' : 'block'} absolute right-0 top-0 z-[12] -scale-x-100 transform rounded-full border-0 bg-transparent text-[32px] text-white opacity-50`}
			onClick={launchFullscreen}
		>
			⇱
		</button>
	);
};
